var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row h-100-vh justify-content-center bg-black"},[_c('div',{staticClass:"col-12 col-sm-8 col-md-6 d-flex flex-column justify-content-center bg-white"},[_c('LanguageLoader',{staticClass:"p-2 p-lg-5 animated fadeInUp text-center",attrs:{"routeLanguage":"./translations/messages/signup_"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }